// extracted by mini-css-extract-plugin
export var active = "_ck-7";
export var container = "_ck-0";
export var evenWidth = "_ck-4";
export var large = "_ck-5";
export var outlet = "_ck-8";
export var slide = "_ck-2";
export var small = "_ck-6";
export var tab = "_ck-3";
export var tabs = "_ck-1";